import { useEffect, useState } from "react";
import salesChatBg from "../../asset/Sales/salesChatBg.svg";
import image1 from "../../asset/Sales/image1.svg";
import meetingSummaryCard from "../../asset/Sales/Section - MeetingSummaryCard.svg";
import meetingCard1 from "../../asset/Sales/Discovery Phase Card.svg";
import meetingCard2 from "../../asset/Sales/Solution Phase Card.svg";
import meetingCard3 from "../../asset/Sales/Objection Handling Phase Card.svg";
import meetingCard4 from "../../asset/Sales/Closing Phase Card.svg";
import salesRepCard1 from "../../asset/Sales/Section - WhatWentWell.svg";
import salesRepCard2 from "../../asset/Sales/Section - AreasToImprove.svg";
import productPerformanceGrid from "../../asset/Sales/ProductPerformanceGrid → Section - ProductPerformanceCard.svg";
import featureOfInterest from "../../asset/Sales/Section - FeaturesOfInterest.svg";
import requestedFeatures from "../../asset/Sales/Section - FeatureRequests.svg";
const SALES_REP_CARDS = [
  salesRepCard1,
  salesRepCard2,
];

const MEETING_CARDS = [meetingCard1, meetingCard2, meetingCard3, meetingCard4];
const STEPS = [
  "Summary",
  "Meeting Phase",
  "SalesRep Analysis",
  "Product Analysis",
];

const MESSAGES = [
  {
    from: "agent",
    text: "Good morning, Rajesh. Thank you for taking the time to meet with us today. How are you doing?",
  },
  { from: "customer", text: "Good morning. I'm doing well, thank you." },
  {
    from: "agent",
    text: "Great to hear that. Before we begin, could you tell me a little about your current hiring process and how you're handling background verification today?",
  },
  {
    from: "customer",
    text: "Currently, we work with a verification vendor. Most of the process is manual and takes around 7\u201310 days.",
  },
];

const LOOP = 11;
const STEP_ON = [
  0, // Summary starts
  2, // Meeting starts after 2s
  6, // SalesRep starts after Meeting's 5s
  8, // Product starts
  11, // Loop restart
];
const MSG_IN = [0.3, 2.5, 3.4, 4.3]; // when each message pops in
const FADE = [11, 11];
const pct = (s) => `${(s / LOOP) * 100}%`;

const poppins = { fontFamily: "'Poppins',sans-serif" };

export default function HowItWorks() {
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    const t = requestAnimationFrame(() => setMounted(true));
    return () => cancelAnimationFrame(t);
  }, []);

  return (
    <section className="w-full px-4 sm:px-6 md:px-10 lg:px-28 py-16 md:py-20">
      <style>{`
        .sa-fade-up{opacity:0;transform:translateY(24px);transition:opacity .8s ease,transform .8s ease}
        .sa-in{opacity:1!important;transform:translateY(0)!important}
.sa-inline-card{
    width:25%;
    height:250px;
    display:flex;
    align-items:center;
    justify-content:center;
    opacity:0;
    transform:translateY(20px) scale(.95);
}
.sa-inline-card{
    width:100%;
    height:120px;
}

@media (min-width:768px){

.sa-inline-card{
    height:220px;
}

}

@media (min-width:1024px){

.sa-inline-card{
    height:250px;
}

}

.sa-inline-card img{
    width:100%;
    height:100%;
    object-fit:contain;
}

/* Use the same LOOP (11s) as the rest of the component */
.sa-inline-card-0{
    animation:sa-inline-card-0 11s linear infinite;
}
.sa-inline-card-1{
    animation:sa-inline-card-1 11s linear infinite;
}
.sa-inline-card-2{
    animation:sa-inline-card-2 11s linear infinite;
}
.sa-inline-card-3{
    animation:sa-inline-card-3 11s linear infinite;
}

@keyframes sa-inline-card-0{
  0%,18%{
    opacity:0;
    transform:translateY(20px) scale(.95);
  }

  19%,54%{
    opacity:1;
    transform:translateY(0) scale(1);
  }

  55%,100%{
    opacity:1;
    transform:translateY(0) scale(1);
  }
}

@keyframes sa-inline-card-1{
  0%,26%{
    opacity:0;
    transform:translateY(20px) scale(.95);
  }

  30%,54%{
    opacity:1;
    transform:translateY(0) scale(1);
  }

  55%,100%{
    opacity:1;
    transform:translateY(0) scale(1);
  }
}

@keyframes sa-inline-card-2{
  0%,34%{
    opacity:0;
    transform:translateY(20px) scale(.95);
  }

  38%,54%{
    opacity:1;
    transform:translateY(0) scale(1);
  }

  55%,100%{
    opacity:1;
    transform:translateY(0) scale(1);
  }
}

@keyframes sa-inline-card-3{
  0%,42%{
    opacity:0;
    transform:translateY(20px) scale(.95);
  }

  46%,54%{
    opacity:1;
    transform:translateY(0) scale(1);
  }

  55%,100%{
    opacity:1;
    transform:translateY(0) scale(1);
  }
}
 .sa-sales-inline-card{
    width:100%;
    height:140px;
    display:flex;
    align-items:center;
    justify-content:center;

    opacity:0;
    transform:translateY(20px);

    animation-duration:11s;
    animation-timing-function:linear;
    animation-iteration-count:infinite;
    animation-fill-mode:both;
}

.sa-sales-inline-card img{
    width:100%;
    height:100%;
    object-fit:contain;
}

.sa-sales-inline-card img{
    width:100%;
    height:100%;
    object-fit:contain;
}

/* Tablet & Desktop */
@media (min-width:768px){

.sa-sales-inline-card{
    width:50%;
    height:230px;
}

}
.sa-sales-inline-card-0{
    animation-name:salesCard1;
}

.sa-sales-inline-card-1{
    animation-name:salesCard2;
}


/* Card 1 */
@keyframes salesCard1{

    /* Hidden before SalesRep starts */
    0%,54%{
        opacity:0;
        transform:translateY(20px);
    }

    /* Fade up */
    56%,61%{
        opacity:1;
        transform:translateY(0);
    }

    /* Stay visible */
    61%,81%{
        opacity:1;
        transform:translateY(0);
    }

    /* Hide */
    82%,100%{
        opacity:0;
        transform:translateY(-10px);
    }
}


/* Card 2 */
@keyframes salesCard2{

    /* Hidden */
    0%,63%{
        opacity:0;
        transform:translateY(20px);
    }

    /* Pop after card1 */
    65%,70%{
        opacity:1;
        transform:translateY(0);
    }

    /* Stay visible */
    70%,81%{
        opacity:1;
        transform:translateY(0);
    }

    /* Hide */
    82%,100%{
        opacity:0;
        transform:translateY(-10px);
    }
}
    .sa-product-card1{
    position:absolute;
    inset:0;

    display:flex;
    align-items:center;
    justify-content:center;

    opacity:0;
    transform:translateY(20px);

    animation:productGrid 11s linear infinite;
}

.sa-product-card1 img{
    width:90%;
    height:100%;
    object-fit:contain;
}

/* second layout */

.sa-product-row{
    display:flex;
    align-items:center;
    justify-content:center;
}

.sa-product-card2,
.sa-product-card3{

    width:50%;
    height:210px;

    opacity:0;
    transform:translateY(20px);
}

.sa-product-card2 img,
.sa-product-card3 img{

    width:100%;
    height:100%;
    object-fit:contain;
}

.sa-product-card2{
    animation:productCard2 11s linear infinite;
}

.sa-product-card3{
    animation:productCard3 11s linear infinite;
}

/* ---------- Animations ---------- */

@keyframes productGrid{

    /* hidden */
    0%,73%{
        opacity:0;
        transform:translateY(20px);
    }

    /* fade in */
    80%,86%{
        opacity:1;
        transform:translateY(0);
    }

    /* show */
    90%,91%{
        opacity:1;
    }

    /* remove */
    92%,100%{
        opacity:0;
        transform:translateY(-15px);
    }
}

@keyframes productCard2{

    /* hidden */
    0%,91%{
        opacity:0;
        transform:translateY(20px);
    }

    /* pop */
    92%,96%{
        opacity:1;
        transform:translateY(0);
    }

    /* stay */
    96%,100%{
        opacity:1;
    }
}

@keyframes productCard3{

    /* hidden */
    0%,93%{
        opacity:0;
        transform:translateY(20px);
    }

    /* pop after left card */
    94%,98%{
        opacity:1;
        transform:translateY(0);
    }

    /* stay */
    98%,100%{
        opacity:1;
    }
}
    .sa-product-card2,
.sa-product-card3{

    width:100%;
    height:120px;
}

@media(min-width:1024px){

.sa-product-card2,
.sa-product-card3{

    width:50%;
    height:210px;
}

}
        ${STEPS.map((_, i) => {
          const start = STEP_ON[i];
          const end = i < STEPS.length - 1 ? STEP_ON[i + 1] : FADE[0];
          return `
        @keyframes sa-step-${i}{
          0%{background:#FFFFFF;color:#3F3D3C;border-color:#ECECEC;box-shadow:0 2px 6px rgba(0,0,0,0.03);transform:scale(1)}
          ${pct(start - 0.1)}{background:#FFFFFF;color:#3F3D3C;border-color:#ECECEC;box-shadow:0 2px 6px rgba(0,0,0,0.03);transform:scale(1)}
          ${pct(start)}{background:#EB604A;color:#FFFFFF;border-color:#EB604A;box-shadow:0 10px 22px rgba(235,96,74,0.28);transform:scale(1.015)}
          ${pct(end - 0.05)}{background:#EB604A;color:#FFFFFF;border-color:#EB604A;box-shadow:0 10px 22px rgba(235,96,74,0.28);transform:scale(1.015)}
          ${pct(end)}{background:#FFFFFF;color:#3F3D3C;border-color:#ECECEC;box-shadow:0 2px 6px rgba(0,0,0,0.03);transform:scale(1)}
          ${pct(FADE[1])}{background:#FFFFFF;color:#3F3D3C;border-color:#ECECEC;box-shadow:0 2px 6px rgba(0,0,0,0.03);transform:scale(1)}
          100%{background:#FFFFFF;color:#3F3D3C;border-color:#ECECEC;box-shadow:0 2px 6px rgba(0,0,0,0.03);transform:scale(1)}
        }
        @keyframes sa-conn-${i}{
          0%{opacity:0}
          ${pct(start - 0.1)}{opacity:0}
          ${pct(start)}{opacity:1}
          ${pct(end - 0.05)}{opacity:1}
          ${pct(end)}{opacity:0}
          100%{opacity:0}
        }`;
        }).join("\n")}

        ${MESSAGES.map((_, i) => {
          const inAt = MSG_IN[i];
          return `
        @keyframes sa-msg-${i}{
          0%{opacity:0;transform:translateY(10px) scale(.9)}
          ${pct(inAt - 0.05)}{opacity:0;transform:translateY(10px) scale(.9)}
          ${pct(inAt + 0.25)}{opacity:1;transform:translateY(0) scale(1)}
         ${pct(inAt + 0.25)}{
    opacity:1;
    transform:translateY(0) scale(1);
}

${pct(FADE[0])}{
    opacity:1;
    transform:translateY(0) scale(1);
}

${pct(FADE[1])}{
    opacity:1;
    transform:translateY(0) scale(1);
}

100%{
    opacity:1;
    transform:translateY(0) scale(1);
}
        }`;
        }).join("\n")}

        ${STEPS.map(
          (_, i) => `
        .sa-step-${i}{animation:sa-step-${i} ${LOOP}s linear infinite}
        .sa-conn-${i}{animation:sa-conn-${i} ${LOOP}s linear infinite}`,
        ).join("\n")}
        ${MESSAGES.map(
          (_, i) =>
            `.sa-msg-${i}{animation:sa-msg-${i} ${LOOP}s linear infinite}`,
        ).join("\n")}

        .sa-chat-mask{
          -webkit-mask-image:linear-gradient(to bottom,transparent,black 36px,black 100%);
          mask-image:linear-gradient(to bottom,transparent,black 36px,black 100%);
        }

        ${STEPS.map((_, i) => {
          const start = STEP_ON[i];
          const end = i < STEPS.length - 1 ? STEP_ON[i + 1] : FADE[0];

          return `
@keyframes sa-panel-${i}{
 0%{
    opacity:0;
    visibility:hidden;
}

100%{
    opacity:0;
    visibility:hidden;
}

  ${pct(start - 0.05)}{
    opacity:0;
    visibility:hidden;
  }

  ${pct(start + 0.05)}{
    opacity:1;
    visibility:visible;
  }

  ${pct(end - 0.05)}{
    opacity:1;
    visibility:visible;
  }

  ${pct(end)}{
    opacity:0;
    visibility:hidden;
  }
}
`;
        }).join("\n")}
${STEPS.map(
  (_, i) => `
.sa-panel-${i}{
    position:absolute;
    inset:0;
animation: sa-panel-${i} ${LOOP}s linear infinite;}
`,
).join("\n")}
      `}</style>

      {/* heading */}
      <div
        className={`max-w-3xl mx-auto text-center sa-fade-up ${mounted ? "sa-in" : ""}`}
      >
        <span className="inline-block mb-3 font-prompt px-4 py-1 rounded-md bg-[#FFE9E4] text-[#EB604A] font-semibold text-xs sm:text-sm">
          How It Works
        </span>
        <h2 className="mt-5 font-bold font-prompt text-[#3F3D3C] text-2xl sm:text-3xl md:text-4xl lg:text-5xl leading-tight">
          Your AI Sales Expert Before, During & After Every Demo
        </h2>
        <p className="mt-4 font-jakarta text-[#0C0200] text-[12px] md:text-[14px] lg:text-[15px] leading-6  max-w-5xl mx-auto">
          Sales AI supports your sales team before, during, and after every
          customer conversation, preparing reps for success, providing live
          guidance throughout the meeting, and delivering actionable insights
          that accelerate deal progression.
        </p>
      </div>

      {/* card */}
      <div
        className={`mt-1 md:mt-14 max-w-6xl mx-auto rounded-[12px]  border-[1px]
    border-dashed shadow-md
    border-[#E8604A] #FFFDFC p-4 sm:p-6 md:p-8 sa-fade-up ${
      mounted ? "sa-in" : ""
    }`}
      >
        <div className="grid grid-cols-1 md:grid-cols-[minmax(0,1fr)_20px_minmax(0,3fr)] gap-4 md:gap-0 items-stretch">
          {/* steps list */}
          <div className="flex flex-col gap-4">
            {STEPS.map((s, i) => (
              <div
                key={s}
                className={`
    relative
    sa-step-${i}
    rounded-[5px]
    text-center
    border
    border-[#FBFBFB]
    px-3
    py-3
    font-prompt
    text-[#555555]
    lg:text-[14px]
    md:text-[12px]
    text-[12px]
  `}
                style={poppins}
              >
                {s}

                {i === 0 && (
                  <div
                    className="
      hidden
      md:block

      absolute

      left-full
      top-1/2

      -translate-y-1/2

      w-[300px]
      h-[17px]

      pointer-events-none
      z-10
    "
                  >
                    {/* Horizontal */}
                    <div
                      className="
        absolute
        top-0
        left-0

        w-[213px]

        border-t
        border-dashed
        border-[#EB604A]
      "
                    />

                    {/* Curve */}
                    <div
                      className="
        absolute
        top-0
        left-[215px]

        w-[90px]
        h-[50px]

        border-t
        border-r
        border-dashed
        border-[#EB604A]

        rounded-tr-full
      "
                    />

                    {/* Vertical */}
                    <div
                      className="
        absolute
        top-[43px]
        left-[255px]

        h-[78px]

        border-r
        border-dashed
        border-[#EB604A]
      "
                    />

                    {/* Bottom Horizontal */}
                    <div
                      className="
        absolute
        top-[118px]
        left-[255px]

        w-[65px]

        border-t
        border-dashed
        border-[#EB604A]
      "
                    />
                  </div>
                )}
              </div>
            ))}
          </div>

          {/* connector rail — desktop only, one dotted curve per step, lit up when that step is active */}
          <div className="hidden md:flex flex-col gap-3">
            {STEPS.map((_, i) => (
              <div
                key={i}
                className="flex-1 flex  items-center justify-center"
              ></div>
            ))}
          </div>

          {/* chat panel */}
          <div
            className="
    relative
    rounded-md
    border-[1.3px]
    border-dashed
    border-[#E8604A]
    overflow-hidden

    p-1
    lg:p-2
    md:p-6
    h-[260px]        
    lg:h-[260px]
    md:h-[240px]
    mt-[20px]
    md:mt-[40px]
    lg:mt-[40px]

    flex
    flex-col
"
            style={{
              backgroundImage: `url(${salesChatBg})`,
              backgroundSize: "750px",
              backgroundPosition: "center",
            }}
          >
            {/* Summary */}
            {/* <div className="sa-panel-0 flex flex-col items-center justify-center h-full px-8 text-center">
  <h3 className="font-prompt text-[18px] lg:text-[22px] md:text[20px] font-semibold text-[#3F3D3C] mb-5">
    Conversation Summary
  </h3>

  <p className="font-jakarta text-[10px] md:text[14px lg:text-[14px] leading-4 md:leading-6 lg:leading-7 text-[#555] max-w-xl">
    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod
    tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim
    veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea
    commodo consequat.
  </p>
</div> */}
            {/* Summary */}
            <div className="sa-panel-0 h-full flex items-center px-5 md:px-8">
<div className="grid grid-cols-1 lg:grid-cols-[1fr_300px] gap-2 items-center w-full">                {/* Left Content */}
               <div className="hidden lg:block">
  <h3 className="font-prompt text-[18px] font-semibold text-[#3F3D3C] mb-4">
    Conversation Summary
  </h3>

  <p className="font-jakarta text-[12px] text-[#64748B] leading-5 text-[#555]">
    The meeting with TechNova Solutions focused on understanding
    their background verification challenges and how our platform
    can help streamline their process.
  </p>
</div>

                {/* Right Small Card */}
                <div className="flex justify-center">
  <div className="bg-white rounded-xl shadow-sm border border-[#F3E7E4] p-3 w-full max-w-[350px] md:max-w-[250px] lg:max-w-[300px]">
    <img
      src={meetingSummaryCard}
      alt="Meeting Summary"
      className="w-full h-auto object-contain"
    />
  </div>
</div>
              </div>
            </div>

            <div className="sa-panel-1 h-full flex items-center px-8">
<div className="w-full grid grid-cols-2 md:grid-cols-4 gap-2 md:gap-0">
  {MEETING_CARDS.map((card, index) => (
    <div
      key={index}
      className={`sa-inline-card sa-inline-card-${index}`}
    >
      <img
        src={card}
        alt={`Card ${index + 1}`}
        className="w-full h-full object-contain"
      />
    </div>
  ))}
</div>
            </div>

            {/* SalesRep Analysis */}
<div className="sa-panel-2 h-full flex items-center px-5">
<div className="w-full flex flex-col md:flex-row items-center gap-0 md:gap-4 lg:gap-4">
      {SALES_REP_CARDS.map((card, index) => (
      <div
        key={index}
        className={`sa-sales-inline-card sa-sales-inline-card-${index}`}
      >
        <img
          src={card}
          alt={`Sales Card ${index + 1}`}
          className="w-full h-full object-contain"
        />
      </div>
    ))}
  </div>
</div>

            {/* Product Analysis */}
          {/* Product Analysis */}
<div className="sa-panel-3 h-full flex items-center justify-center px-5">

  {/* First Card */}
  <div className="sa-product-card1">
    <img
      src={productPerformanceGrid}
      alt="Product Performance"
      className="w-full h-full object-contain"
    />
  </div>

  {/* Second Layout */}
<div className="sa-product-row w-full flex flex-col lg:flex-row gap-3 lg:gap-4">
      <div className="sa-product-card2">
      <img
        src={featureOfInterest}
        alt="Area To Improve"
        className="w-full h-full object-contain"
      />
    </div>

    <div className="sa-product-card3">
      <img
        src={requestedFeatures}
        alt="Requested Features"
        className="w-full h-full object-contain"
      />
    </div>
  </div>

</div>
          </div>
        </div>
      </div>
    </section>
  );
}
